import React, { useState } from "react";
import Card from "components/card";
import { createAgeGrade } from "services/ageGrades";
import { useToast } from "components/Toast";
import { useNavigate } from "react-router-dom";

const CreateAgeGrade: React.FC = () => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await createAgeGrade({ name, description });
      navigate("/admin/age-grades");
    } catch (err) {
      console.error(err);
      toast.showError("Failed to create age grade");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card extra="w-full p-4">
      <h2 className="mb-4 text-2xl font-bold">Create Age Grade</h2>
      <form onSubmit={handleSubmit} className="max-w-md space-y-4">
        <div>
          <label className="block">Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="input"
            required
          />
        </div>
        <div>
          <label className="block">Description</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="input"
            rows={4}
          />
        </div>
        <div>
          <button
            className="btn btn-primary"
            type="submit"
            disabled={submitting}
          >
            {submitting ? "Creating..." : "Create"}
          </button>
        </div>
      </form>
    </Card>
  );
};

export default CreateAgeGrade;
